export const POLICY_NOTE = "— no district change; statutory plan amendment";
export const DC_BYLAW_NOTE = "— DC bylaw amendment";

// Calgary-local "Mon May 12" for the per-row deadline sub-line. The
// time component is a fixed 12:00 because the City's 8-day rule pins
// every submission deadline to noon Calgary time (FR-012).
export const ROW_DEADLINE_FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Edmonton",
  weekday: "short",
  month: "short",
  day: "numeric",
});

// Row sub-line under the relative-deadline label: "closes Mon May 12 ·
// 12:00" while the window is open, "closed …" after it has passed, and
// a placeholder when the upstream hasn't published a deadline yet.
export function formatDeadlineSub(
  submissionDeadlineUtc: string | null,
  closed: boolean,
): string {
  if (!submissionDeadlineUtc) return "no deadline yet";
  const date = ROW_DEADLINE_FMT.format(new Date(submissionDeadlineUtc));
  return `${closed ? "closed" : "closes"} ${date} · 12:00`;
}

export const DAY_DOW_FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Edmonton",
  weekday: "long",
});

export const DAY_HEAD_FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Edmonton",
  month: "long",
  day: "numeric",
});

export const DAY_YEAR_FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Edmonton",
  year: "numeric",
});

export const DEADLINE_DATE_FMT = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Edmonton",
  weekday: "short",
  month: "short",
  day: "numeric",
});
